module.exports = __webpack_public_path__ + "img/propStatus4.0c4b6b46.png";